import { Canvas } from "@react-three/fiber";
import FloatingShapes from "./ContactCanvas/FloatingShapes";

function ContactCanvas({ mouseRef, darkMode }) {
  return (
    <div style={{ position: "absolute", top: 0, bottom: 0, left: "-20%", right: "-20%", pointerEvents: "none" }}>
      <Canvas
        orthographic
        camera={{ position: [0, 0, 10], zoom: 90 }}
        gl={{ alpha: true, antialias: true }}
        style={{ background: "transparent" }}
      >
        <FloatingShapes mouseRef={mouseRef} darkMode={darkMode} />
      </Canvas>
    </div>
  );
}

export default ContactCanvas;
